// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"bcad7bda","626":"b1beaa2d","636":"0c1a0645"}[chunkId] + ".chunk.js";
};